module.exports = __webpack_public_path__ + "img/total.79fd32dc.svg";